import { createContext, PropsWithChildren, useContext } from 'react';
import { CustomerDetail } from '../../main/model/CustomerTypes';
import CustomerApiAgent from '../../main/agent/CustomerApiAgent';

type Context = {
  customerId: string;
  isCustomerDetailLoading: boolean;
  customerDetail?: CustomerDetail;
};

export const CustomerDetailPageContext = createContext<Context>({} as Context);

interface CustomerDetailPageContextProviderProps extends PropsWithChildren {
  customerId: string;
}

export const CustomerDetailPageContextProvider: React.FC<CustomerDetailPageContextProviderProps> = ({
  children,
  customerId,
}) => {
  const { data: customerDetail, isLoading: isCustomerDetailLoading } =
    CustomerApiAgent.useGetCustomerDetail(customerId);

  return (
    <CustomerDetailPageContext.Provider
      value={{
        customerId,
        isCustomerDetailLoading,
        customerDetail,
      }}>
      {children}
    </CustomerDetailPageContext.Provider>
  );
};

export const useCustomerDetailPageContext = () => useContext(CustomerDetailPageContext);
